import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, InputWithSearchIcon } from 'common/components';
import { MAIN_ROUTES } from 'common/config';
import { ACTION_ITEMS } from 'common/config/action.config';

import { Mode } from 'modules/master-data/enums/mode.enum';

import './Header.scss';
import { ButtonLabel, ButtonVariant, EntityActions } from 'common/enums';
import { ExportRequestDto } from 'modules/master-data/models/export.model';
import { ExtractType } from 'common/enums/data.enum';

type HeaderProps = {
    reviewStatus: boolean | undefined;
    dataEditorMode: string;
    showAddCategoryPopup: () => void;
    isDisabled?: boolean;
    searchVal: string;
    isAddNewCategoryButtonDisabled: boolean;
    isMapToGBBPublicDisabled: boolean;
    isSyncInProgress: boolean;
    isExportActionDisabled: boolean;
    isApplyDiscardDisabled: boolean;
    onSearchChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
    applyChanges: (EntityAction: string) => void;
    onChangeDiscard: () => void;
    showExportPopup: (data: ExportRequestDto) => void;
};

const Header: FC<HeaderProps> = ({
    reviewStatus,
    dataEditorMode,
    showAddCategoryPopup,
    isDisabled,
    searchVal,
    isAddNewCategoryButtonDisabled,
    isMapToGBBPublicDisabled,
    isSyncInProgress = false,
    isExportActionDisabled = false,
    isApplyDiscardDisabled = false,
    onSearchChangeHandler,
    applyChanges,
    onChangeDiscard,
    showExportPopup
}: HeaderProps) => {
    /**
     * Do not remove this comment
     * It will be included in near future.
     */
    // const navigate = useNavigate();
    // const handleMapToVariant = () => {
    //     navigate(MAIN_ROUTES.VARIANTS);
    // };

    const exportRequestPayload: ExportRequestDto = {
        extractType: ExtractType.FullData
    };

    return (
        <div className="master-data-header-container">
            <div className={`master-data-header ${'header-default'}`}>Master Data</div>
            <div className="header-right">
                {/**
                 * Do not remove this comment
                 * It will be included in near future.
                 */
                /* {(dataEditorMode === Mode.Initial || dataEditorMode === Mode.DataLoaded) && (
                    <Button variant="secondary" className="transparent-bg">
                        Export list
                    </Button>
                )}
                {(dataEditorMode === Mode.Initial || dataEditorMode === Mode.DataLoaded) && (
                    <Button
                        variant="secondary"
                        className="transparent-bg"
                        onClick={handleMapToVariant}>
                        Map to variant
                    </Button>
                )} */}
                {dataEditorMode !== Mode.SyncInProgress && (
                    <>
                        <InputWithSearchIcon
                            placeholder={ACTION_ITEMS.SEARCH_BUTTON}
                            value={searchVal}
                            className="search-input"
                            hideClearButton={false}
                            onChange={onSearchChangeHandler}
                        />
                        <Button
                            disabled={isExportActionDisabled || isSyncInProgress}
                            onClick={() => showExportPopup(exportRequestPayload)}
                            variant="secondary"
                            className="transparent-bg">
                            {ButtonLabel.EXPORT_LIST}
                        </Button>
                        <Button
                            onClick={showAddCategoryPopup}
                            className={`${
                                reviewStatus ? 'transparent-bg' : 'master-data-header-button'
                            }`}
                            variant={`${reviewStatus ? 'secondary' : 'primary'}`}
                            disabled={isAddNewCategoryButtonDisabled || isDisabled}>
                            {ButtonLabel.ADD_CATEGORY}
                        </Button>
                        {reviewStatus && (
                            <>
                                <div className="seperator"></div>
                                <Button
                                    onClick={() => onChangeDiscard()}
                                    className="transparent-bg"
                                    variant={ButtonVariant.Secondary}
                                    disabled={isApplyDiscardDisabled || isDisabled}>
                                    {ButtonLabel.DiscardChanges}
                                </Button>
                                <Button
                                    onClick={() => applyChanges(EntityActions.Apply)}
                                    className="master-data-header-button"
                                    disabled={isApplyDiscardDisabled || isDisabled}>
                                    {ButtonLabel.APPLY_CHANGES}
                                </Button>
                            </>
                        )}
                        {!reviewStatus && (
                            <>
                                <div className="seperator"></div>
                                <Button
                                    variant="secondary"
                                    className="transparent-bg"
                                    /**
                                     * Do not remove this comment
                                     * It will be included in near future.
                                     */
                                    // onClick={handleMapToVariant}
                                    onClick={() => applyChanges(EntityActions.GBBPublic)}
                                    disabled={isMapToGBBPublicDisabled}>
                                    {ButtonLabel.MAP_TO_GBB_PUBLIC}
                                </Button>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default Header;
